import { ProtocolContentData } from "../../protocol";
export default class StressAndStabilityAtSea extends ProtocolContentData {
    draftForward;
    draftMidship;
    draftAft;
    draftMeasurementPositionForward;
    draftMeasurementPositionMidship;
    draftMeasurementPositionAft;
    waterDensity;
    gzCurve;
    rightingLeverGz;
    gm;
    shearForces;
    bending;
    torsion;
    loadlineZone;
    freeText;
    constructor(draftForward, draftMidship, draftAft, draftMeasurementPositionForward, draftMeasurementPositionMidship, draftMeasurementPositionAft, waterDensity, gzCurve, rightingLeverGz, gm, shearForces, bending, torsion, loadlineZone, freeText) {
        super();
        this.draftForward = draftForward;
        this.draftMidship = draftMidship;
        this.draftAft = draftAft;
        this.draftMeasurementPositionForward = draftMeasurementPositionForward;
        this.draftMeasurementPositionMidship = draftMeasurementPositionMidship;
        this.draftMeasurementPositionAft = draftMeasurementPositionAft;
        this.waterDensity = waterDensity;
        this.gzCurve = gzCurve;
        this.rightingLeverGz = rightingLeverGz;
        this.gm = gm;
        this.shearForces = shearForces;
        this.bending = bending;
        this.torsion = torsion;
        this.loadlineZone = loadlineZone;
        this.freeText = freeText;
    }
}
//# sourceMappingURL=StressAndStabilityAtSea.js.map